import React, {PropTypes} from 'react';


function PrelimMessage(props) {
  return (
    <div className='welcome-message'>
      <div className='prelim-message-body message-body'>
        You will receive an email from the Qualifying Specialist {props.profile.qualifyingspecialist.firstName} {props.profile.qualifyingspecialist.lastName} you have been assigned to
        who will also contact you shortly to discuss the WAHVE opportunity.
        We look forward to working with you.
      </div>
    </div>
  );
}


export default PrelimMessage;

PrelimMessage.propTypes = {
  profile: PropTypes.object
};



// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/r_ApplicationForm/r_CreateUserModal/f_PrelimMessage/index.js